import { useContext, useEffect } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';

const AllPayment = ({ Amount, PaymentUrl }) => {

    const { BaseUrl, setPaymentLoading } = useContext(MyContext);

    useEffect(() => {
        if (!Amount || !PaymentUrl) return;
        handleGetPymentUrl();
    }, [Amount, PaymentUrl]);

    const handleGetPymentUrl = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const redirectBackUrl = encodeURIComponent(`${window.location.origin}/payment-response`);
        window.location.href = `${BaseUrl + PaymentUrl}amount=${Amount}&uid=${Userid}&redirect_url=${redirectBackUrl}`;
        setPaymentLoading(false);
    }

    return null
}

export default AllPayment